// extracted by mini-css-extract-plugin
module.exports = {"list":"Contacts_list__EGsus","active":"Contacts_active__3FF9n","inactive":"Contacts_inactive__1WG-1","avatar":"Contacts_avatar__1iyou"};